import {action, observable, runInAction} from 'mobx'
import {decorate, inject, injectable} from '@yosmanyga/di'
// import {PhoneType, resolvePrefix} from '@yosmanyga/phone'
import {AuthenticationFrontendWithPhoneAbstractApi} from '../../data'

class AuthenticationFrontendWithPhoneStartController {
    // @observable accessor country: PhoneType['country'] | undefined
    // @observable accessor prefix: PhoneType['prefix'] | undefined
    // @observable accessor number: PhoneType['number'] | undefined
    // @observable accessor error!: string
    @observable accessor loading: boolean
    @observable accessor starting: boolean
    @observable accessor started: boolean

    constructor(
        private authenticationFrontendApi: AuthenticationFrontendWithPhoneAbstractApi,
    ) {
        this.loading = true
        this.starting = false
        this.started = false
    }
    //
    // @action load = (
    //     country?: PhoneType['country'],
    //     prefix?: PhoneType['prefix'],
    //     number?: PhoneType['number'],
    // ) => {
    //     runInAction(() => {
    //         this.country = country
    //         this.prefix = prefix
    //         this.number = number
    //         this.loading = false
    //     })
    // }
    //
    // @action prepare = (
    //     {
    //         country,
    //         number
    //     }: {
    //         country?: PhoneType['country'],
    //         number?: PhoneType['number'],
    //     }
    // ) => {
    //     runInAction(() => {
    //         this.error = ''
    //         this.country = typeof country !== 'undefined' ? country : this.country
    //         this.prefix = typeof country !== 'undefined' ? resolvePrefix(country) : this.prefix
    //         this.number = typeof number !== 'undefined' ? number : this.number
    //     })
    // }
    //
    // @action start = async () => {
    //     runInAction(() => {
    //         this.error = ''
    //         this.starting = true
    //     })
    //
    //     if (!this.country) {
    //         runInAction(() => {
    //             this.error = 'Selecciona el país'
    //             this.starting = false
    //         })
    //
    //         return
    //     }
    //
    //     if (!this.number) {
    //         runInAction(() => {
    //             this.error = 'Escribe el número de teléfono'
    //             this.starting = false
    //         })
    //
    //         return
    //     }
    //
    //     let phone
    //
    //     try {
    //         // phone = buildPhone(this.number, this.country)
    //     } catch (e) {
    //         runInAction(() => {
    //             this.error = 'El número es incorrecto. Verifícalo'
    //             this.starting = false
    //         })
    //
    //         return
    //     }
    //
    //     // await this.authenticationFrontendApi.start(phone)
    //
    //     runInAction(() => {
    //         this.starting = false
    //         this.started = true
    //     })
    // }
}

decorate(injectable(), AuthenticationFrontendWithPhoneStartController)
decorate(inject(AuthenticationFrontendWithPhoneAbstractApi), AuthenticationFrontendWithPhoneStartController, 0)

export {
    AuthenticationFrontendWithPhoneStartController
}
